// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"82df7af2","239":"b12e5ddc","453":"87aaa12e","455":"626ba6d8"}[chunkId] + ".chunk.js";
};